export default __webpack_public_path__ + "static/media/biodata.e8f8070b.svg";